'use strict';

require("core-js/modules/es6.array.some");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.string.trim");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.array.index-of");

var he = require('he');

var lowercase = require('./lowercase');

var attributes = require('./attributes');

var elements = require('./elements');

function sanitizer(buffer, options) {
  var last;
  var context;
  var o = options || {};
  reset();
  return {
    start: start,
    end: end,
    chars: chars
  };

  function out(value) {
    buffer.push(value);
  }

  function start(tag, attrs, unary) {
    var low = lowercase(tag);

    if (context.ignoring) {
      ignore(low);
      return;
    }

    if ((o.allowedTags || []).indexOf(low) === -1) {
      ignore(low);
      return;
    }

    if (o.filter && !o.filter({
      tag: low,
      attrs: attrs
    })) {
      ignore(low);
      return;
    }

    out('<');
    out(low);
    Object.keys(attrs).forEach(parse);
    out(unary ? '/>' : '>');

    function parse(key) {
      var value = attrs[key];
      var classesOk = (o.allowedClasses || {})[low] || [];
      var attrsOk = (o.allowedAttributes || {})[low] || [];
      var valid;
      var lkey = lowercase(key);

      if (lkey === 'class' && attrsOk.indexOf(lkey) === -1) {
        value = value.split(' ').filter(isValidClass).join(' ').trim();
        valid = value.length;
      } else {
        valid = attrsOk.indexOf(lkey) !== -1 && (attributes.uris[lkey] !== true || testUrl(value));
      }

      if (valid) {
        out(' ');
        out(key);

        if (typeof value === 'string') {
          out('="');
          out(he.encode(value));
          out('"');
        }
      }

      function isValidClass(className) {
        return classesOk && classesOk.indexOf(className) !== -1;
      }
    }
  }

  function end(tag) {
    var low = lowercase(tag);
    var allowed = (o.allowedTags || []).indexOf(low) !== -1;

    if (allowed) {
      if (context.ignoring === false) {
        out('</');
        out(low);
        out('>');
      } else {
        unignore(low);
      }
    } else {
      unignore(low);
    }
  }

  function testUrl(text) {
    var start = text[0];

    if (start === '#' || start === '/') {
      return true;
    }

    var colon = text.indexOf(':');

    if (colon === -1) {
      return true;
    }

    var questionmark = text.indexOf('?');

    if (questionmark !== -1 && colon > questionmark) {
      return true;
    }

    var hash = text.indexOf('#');

    if (hash !== -1 && colon > hash) {
      return true;
    }

    return o.allowedSchemes.some(matches);

    function matches(scheme) {
      return text.indexOf(scheme + ':') === 0;
    }
  }

  function chars(text) {
    if (context.ignoring === false) {
      out(o.transformText ? o.transformText(text) : text);
    }
  }

  function ignore(tag) {
    if (elements.voids[tag]) {
      return;
    }

    if (context.ignoring === false) {
      context = {
        ignoring: tag,
        depth: 1
      };
    } else if (context.ignoring === tag) {
      context.depth++;
    }
  }

  function unignore(tag) {
    if (context.ignoring === tag) {
      if (--context.depth <= 0) {
        reset();
      }
    }
  }

  function reset() {
    context = {
      ignoring: false,
      depth: 0
    };
  }
}

module.exports = sanitizer;